import React from "react";
import {Link} from "react-router-dom";
import moment from "moment";

export const COMMERCIAL_SIGNED_QUOTES_COLUMNS = [
	{
		Header: "Numéro client",
		accessor: "project.client.reference"
	},
	{
		Header: "Nom du client",
		accessor: "project.client.lastname",
		Cell: cellInfo => {
			return (
				<Link to={`/client/${cellInfo.row.original.project.client.id}`}>{cellInfo.row.original.project.client.firstname} {cellInfo.row.original.project.client.lastname}</Link>
			)
		}
	},
	{
		Header: "Typologie projet",
		accessor: "project.type"
	},
	{
		Header: "Gestionnaire projet",
		accessor: "project.arch",
		Cell: cellInfo => {
			const arch = cellInfo.row.original.project.arch ? true : false;
			return arch ? (
				<img style={{width: "45px", height: "45px"}} src={"/images/pictos/responsable.svg"} alt={"Gestionnaire projet"} title={"Gestionnaire projet"} />
			) : (
				<span>N/A</span>
			)
		}
	},
	{
		Header: "Date de signature",
		accessor: "signedAt",
		Cell: cellInfo => {
			let date = "NA";
			if (cellInfo.row.original.signedAt) {
				date = new Date(cellInfo.row.original.signedAt)
				date = moment(date).format("DD/MM/YYYY");
			}
			return date
		}
	},
	{
		Header: "Date de visite",
		accessor: "createdAt",
		Cell: cellInfo => {
			let date = "Pas de visite";
			if (cellInfo.row.original.project.visit) {
				date =  new Date(cellInfo.row.original.project.visit.startAt);
				date = moment(date).format("DD/MM/YYYY");
			}
			return date
		}
	},
	{
		Header: "Montant devis (HT)",
		accessor: "total",
		Cell: cellInfo => {
			let total = 0
			if (cellInfo.row.original.total) {
				total = cellInfo.row.original.total.toFixed(2) + " €"
			} else {
				total = "0.00 €"
			}
			return total
		}
	},

	{
		Header: "",
		accessor: "details",
		Cell: cellInfo => {
			return (
				<Link className="btn-little btn-default-primary color-primary" to={`/projet/${cellInfo.row.original.project.id}`}>Accéder aux documents</Link>
			)
		}
	}
]
